export default class ProfileFilterDTO {

    public searchQuery: string | null = null;

    constructor(init?: Partial<ProfileFilterDTO>) {
        Object.assign(this, init);
    }
}